import React, { Fragment } from 'react'
import 'moment/locale/ja'
import { getFromNowAsText } from '../../helpers/timeHelper'
import { getGpsTrackerCommunicationWarningMessage } from '../../helpers/gpsTrackerCommunicationWarning'
import {
  GPS_TRACKER_LOCATION_STALE_WARNING_MESSAGE,
  shouldShowGpsTrackerLocationStaleWarning,
} from '../../helpers/gpsTrackerLocationWarning'
import getGpsTrackerLocationUpdatedAt from '../../helpers/gpsTrackerLocationUpdatedAt'
import {
  iconGpsTracker,
} from '../../icons'
import BatteryRemaining from '../common/BatteryRemaining'

type Props = {
  tracker: IGpsTracker
  onClickList?: () => void
}

const GpsTrackersListItem = ({
  tracker,
  onClickList,
}: Props) => {
  const communicationWarningMessage = getGpsTrackerCommunicationWarningMessage(tracker.status)
  const shouldShowLocationWarning = shouldShowGpsTrackerLocationStaleWarning(tracker.status)
  const locationUpdatedAt = getGpsTrackerLocationUpdatedAt(tracker.status)

  const formatTimestamp = (timestamp?: string | null) => {
    if (!timestamp) return '-'
    return getFromNowAsText(timestamp)
  }

  return (
    <Fragment key={tracker.device_token}>
      <tr
        className="list-row overview-item-list-item"
        key={tracker.device_token}
        onClick={onClickList}
        style={{ cursor: onClickList ? 'pointer' : 'default' }}
      >
        {/* ----- アイテム名 ----- */}
        <td className="item item-name">
          <div className="img-name-item">
            <img className="item-icon" src={iconGpsTracker} alt="gps-tracker" />
            <strong className="item-name-text">
              {tracker.name}
            </strong>
          </div>
        </td>
        {/* ----- 定期通信 ----- */}
        <td className="item item-last-detected-at">
          <div>
            {formatTimestamp(tracker.status?.heartbeat_received_at)}
          </div>
          {communicationWarningMessage && (
            <div className="gps-tracker-communication-warning" role="status">
              <span className="gps-tracker-communication-warning__icon" aria-hidden="true">!</span>
              <span className="gps-tracker-communication-warning__message">
                {communicationWarningMessage}
              </span>
            </div>
          )}
        </td>
        {/* ----- 端末の情報取得 ----- */}
        <td className="item item-last-detected-at">
          {formatTimestamp(tracker.status?.tracked_at)}
        </td>
        {/* ----- GPS+Wi-Fiによる位置更新時刻 ----- */}
        <td className="item item-last-detected-at">
          <div>
            {formatTimestamp(locationUpdatedAt)}
          </div>
          {shouldShowLocationWarning && (
            <div className="gps-tracker-location-warning" role="status">
              <span className="gps-tracker-location-warning__icon" aria-hidden="true">!</span>
              <span className="gps-tracker-location-warning__message">
                {GPS_TRACKER_LOCATION_STALE_WARNING_MESSAGE}
              </span>
            </div>
          )}
        </td>
        {/* ----- 携帯基地局による位置更新時刻 ----- */}
        <td className="item item-last-detected-at">
          {formatTimestamp(tracker.status?.cellular?.observed_at)}
        </td>
        {/* ----- 所持者 ----- */}
        <td className="item">
          <div className="status">
            <div className="main">
              <div className="sub">
                <span className="rental-owner">
                  {tracker.user ? tracker.user.name : '-'}
                </span>
              </div>
            </div>
          </div>
        </td>
        {/* ----- バッテリー残量 ----- */}
        <td className="item">
          <BatteryRemaining percentage={tracker.status?.battery_percentage} />
        </td>
      </tr>

      <tr key={`divider-${tracker.device_token}`} className="divider">
        <td colSpan={7}>
          <div className="line" />
        </td>
      </tr>
    </Fragment>
  )
}

export default GpsTrackersListItem
